import type { PageResponse, Product, ProductUnit } from "./types";

export type ProductResponse = Omit<Product, "default_unit"> & {
  default_unit: string;
};

export type ProductPageResponse = Omit<PageResponse<Product>, "items"> & {
  items: ProductResponse[];
};

export function normalizeProductUnit(unit: string): ProductUnit {
  switch (unit) {
    case "CAIXA":
      return "cx_un";
    case "BDJ":
      return "bdj";
    case "UNIDADE":
      return "un";
    case "KG":
      return "kg";
    case "kg":
    case "cx_kg":
    case "cx_un":
    case "bdj":
    case "un":
    case "sc_kg":
      return unit;
    default:
      return "kg";
  }
}

export function normalizeProduct(product: ProductResponse): Product {
  return {
    ...product,
    default_unit: normalizeProductUnit(product.default_unit),
  };
}

export function normalizeProductPage(
  page: ProductPageResponse,
): PageResponse<Product> {
  return { ...page, items: page.items.map(normalizeProduct) };
}
